<app-layout>
  <div class="event-search container mb-3">
    <!-- Header -->
    <header class="event-search-header">
      <p class="h4">
        Resultados para "<span style="color: #7c0084">{{ searchParams }}</span> "
      </p>
    </header>

    <!-- Filtros -->
    <div class="filter-container">
      <label style="font-size: 1.1em">Filtrar resultados</label>
      <div>
        <div>
          <!-- Filtro por cidade -->
          <label for="city">Cidade</label>
          <select id="city" [(ngModel)]="selectedCity" (change)="applyFilters()">
            <option value="">Todas</option>
            @for (city of cities; track city) {
              <option [value]="city">{{ city }}</option>
            }
          </select>
        </div>
        <div>
          <!-- Filtro por categoria -->
          <label for="category">Categoria</label>
          <select id="category" [(ngModel)]="selectedCategory" (change)="applyFilters()">
            <option value="">Todas</option>
            @for (category of categories; track category) {
              <option [value]="category">{{ category }}</option>
            }
          </select>
        </div>
        <div>
          <!-- Filtro por tipo de evento (Online/Offline) -->
          <label for="isOnline">Tipo</label>
          <select id="isOnline" [(ngModel)]="isOnline" (change)="applyFilters()">
            <option value="">Todos</option>
            <option value="true">Online</option>
            <option value="false">Presencial</option>
          </select>
        </div>
        <div>
          <label for="hasPassed">Status</label>
          <select id="hasPassed" [(ngModel)]="hasPassed" (change)="applyFilters()">
            <option value="">Todos</option>
            <option value="true">Já passou</option>
            <option value="false">Ainda vai acontecer</option>
          </select>
        </div>
      </div>
    </div>

    @if (filteredEvents.length) {
      <div class="results-container">
        @for (event of filteredEvents; track $index) {
          <div class="event-card">
            <app-event-card [event]="event"></app-event-card>
          </div>
        }
      </div>
    } @else {
      <p>Nenhum evento encontrado para os filtros selecionados.</p>
    }
  </div>
</app-layout>
